/** 未登录/登录失效时不强制跳转首页的路由前缀（公开落地页） */
export const AUTH_REDIRECT_EXEMPT_PREFIXES = ["/seer/corporate-center", "/seer/mentor-join"];

export function isAuthRedirectExemptPath(path) {
	if (!path) return false;
	return AUTH_REDIRECT_EXEMPT_PREFIXES.some(
		prefix => path === prefix || path.startsWith(`${prefix}/`)
	);
}
